/**
 * The molecule.dev brand lockup: gradient-clipped "Molecule" + plain ".dev"
 * (+ optional grey suffix, e.g. "Status"), exactly like the landing's
 * `.animate-gradient` hero wordmark. The single brand-rendering component of
 * this app — the header and footer both consume it.
 */

export function BrandWordmark({
  suffix,
  size = 20,
  as = 'span',
  molId = 'brand-wordmark',
}: {
  suffix?: string
  size?: number
  as?: 'span' | 'div'
  molId?: string
}) {
  const Tag = as
  return (
    <Tag className="mol-brand-wordmark" data-mol-id={molId} style={{ fontSize: size }}>
      <span className="mol-gradient-text">Molecule</span>
      <span>.dev</span>
      {suffix ? <span className="mol-brand-wordmark-suffix">{' ' + suffix}</span> : null}
    </Tag>
  )
}
